import { css } from "styled-components";
const animations = {};
const breakpoints = {
	xxl: 1320,
	xl: 1140,
	l: 960,
	s: 720,
	xs: 540,
};
const colors = {
	// Primary - BlockBen Blue (Registration button color)
	primary50: "#F4F5FF",
	primary100: "#DADAFF",
	primary200: "#766BEA",
	primary300: "#5D3FDE",
	primary400: "#493CA3",
	primary500: "#3C357D",
	primary600: "#312E5F",

	// Secondary - BlockBen Cyan/Turquoise (accent color)
	secondary100: "#EEFBFA",
	secondary200: "#C0F3EE",
	secondary300: "#23D0C5",
	secondary400: "#0CB9AB",
	secondary500: "#1A968B",

	// Tertiary
	tertiary100: "#FFD1D7",
	tertiary200: "#FF9AAA",
	tertiary300: "#F16A83",
	tertiary400: "#F3506C",
	tertiary500: "#D53450",

	// netural - BlockBen backgrounds and text colors (100=lightest, 900=darkest #0A0854)
	netural100: "#F9F9FA",
	netural200: "#E9EAEB",
	netural300: "#BEC1C3",
	netural400: "#7A7F86",
	netural500: "#5D646B",
	netural600: "#49515A",
	netural700: "#2E3741",
	netural800: "#18222D",
	netural900: "#0D1722",


	// Success
	success100: "#D1FFDF",
	success200: "#97EEB4",
	success300: "#3BD07C",
	success400: "#38A764",
	success500: "#318256",

	// Warning
	warning100: "#FFDED3",
	warning200: "#FFA781",
	warning300: "#FF792E",
	warning400: "#E05F28",
	warning500: "#B74A25",

	// Danger
	danger100: "#FFE3E2",
	danger200: "#F88178",
	danger300: "#F83B3E",
	danger400: "#D6252A",
	danger500: "#B12221",

	// Overlay
	overlay010: "rgba(13, 23, 34, 0.1)",
	overlay030: "rgba(13, 23, 34, 0.3)",

	// BlockBen specific colors
	backgroundDark: "#e8e8ff",
	backgroundGradientStart: "#e8e8ff",
	backgroundGradientEnd: "#e8e8ff",
	headerBackground: "#E8E8F0",
	navy: "#0D1722",

	// System
	black: "#000000",
	white: "#FFFFFF",
	support: "",
	grayBorder: "#F3F3F4",
	shadow035: "#59181E2D",
	primaryVeryDark: "#211B44",
	primary100Alpha25: "#40DADAFF",
	transparent: "rgba(0,0,0,0)",
	tapOverlay: "#10000000",
	transparentLightOverlay010: "#1AF4F5FF",
	transparentDarkOverlay005: "#0D0D1722",
	transparentDarkOverlay010: "#1A0D1722",
	transparentDarkOverlay030: "#4D0D1722",
	transparentDarkOverlay050: "#800D1722",
	transparentLightOverlay030: "#4DF4F5FF",
	transparentLightOverlay050: "#80FFFFFF",
	successOverlay030: "#4D3BD07C",
	lightGold: "#FFC000",
	darkGold: "#FF8000",
	systemBlack: "#000000",
	systemBlackAlpha40: "#66000000",
	systemBlackAlpha75: "#80000000",
	systemWhite: "#FFFFFF",
	systemPurple: "#7B61FF",
	brandPurple: "#060751",
	lightPurple: "#E1E3FF",
	brandBlue: "#5282FF",
	brandDarkBlue: "#5361FA",
	brandLightBlue: "#939CFF",
	darkBlue: "#00113E",
	chevronGreen: "#00DDA9",
	grey500: "#6C727F",
	grey600: "#394150",
	grey800: "#212121",
	spanishGrey: "#9B9B9B",
};
const fonts = {};
const fontSizes = {};
const spacing = {
	basic: 0.8, // rem
};

const radius = {
	basic: 0.8, //rem
};

const mixins = {
	shadows: {
		primaryCTA: css`
			box-shadow: 0px 10px 20px -10px rgba(91, 121, 217, 0.3), 0px 5px 30px -5px rgba(91, 121, 217, 0.2);
		`,
		elevation1: css`
			box-shadow: 0px 1px 5px rgba(24, 30, 45, 0.05);
		`,
		elevation2: css`
			box-shadow: 0px 2px 15px rgba(24, 30, 45, 0.05);
		`,
		elevation3: css`
			box-shadow: 0px 0px 10px rgba(64, 56, 95, 0.05), 0px 0px 40px rgba(81, 94, 108, 0.05);
		`,
		elevation4: css`
			box-shadow: 0px 4px 10px rgba(24, 30, 45, 0.05), 0px 5px 30px rgba(24, 30, 45, 0.08);
		`,
		elevation5: css`
			box-shadow: 0px 10px 15px rgba(24, 30, 45, 0.05), 0px 20px 40px rgba(56, 56, 56, 0.05);
		`,
		elevation6: css`
			box-shadow: 0px 15px 20px rgba(24, 30, 45, 0.05), 0px 20px 40px rgba(24, 30, 45, 0.05);
		`,
	},
};

const theme = {
	animations,
	breakpoints,
	colors,
	fonts,
	fontSizes,
	spacing,
	radius,
	mixins,
};

export type DefaultThemeProps = typeof theme;
export default theme;

export type ColorType = keyof typeof colors;
